import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { RealtimeSettlementOrderDailySumFilterType, RealtimeSettlementOrderDailySumType } from "../graphql/types/RealtimeSettlementOrderDailySumType";
import {
    RealtimeSettlementOrderDailySumListResponse,
    GET_REALTIME_SETTLEMENT_ORDER_DAILY_SUM_LISTING
} from "../graphql/queries/getRealtimeSettlementOrderDailySumList";

export interface RealtimeSettlementOrderDailySumQueryResult {
    realtimeSettlementOrderDailySumData: RealtimeSettlementOrderDailySumType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useRealtimeSettlementOrderDailySumQuery = (
    filters: RealtimeSettlementOrderDailySumFilterType,
    currentPage: number,
    pageSize: number,
    sumType?: number
) => {
    const [realtimeSettlementOrderDailySumData, setRealtimeSettlementOrderDailySumData] = useState<RealtimeSettlementOrderDailySumType[]>([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);

    const buildQueryVariables = () => {
        const queryFilters = {
            ...filters,
            summaryType: sumType,
        };

        return {
            filters: queryFilters,
            pageRequest: {
                page: currentPage,
                size: pageSize,
                sortBy: "id",
                sortDirection: "DESC"
            }
        };
    };

    // 执行查询
    const { data, loading: queryLoading, refetch } = useQuery<RealtimeSettlementOrderDailySumListResponse>(
        GET_REALTIME_SETTLEMENT_ORDER_DAILY_SUM_LISTING,
        { variables: buildQueryVariables() }
    );

    // 当数据变化时更新状态
    useEffect(() => {
        const responseData = data?.getRealtimeSettlementOrderDailySumPageable?.content;
        if (responseData) {
            setRealtimeSettlementOrderDailySumData(responseData);
            setLoading(false);
        }
        const totalElements = data?.getRealtimeSettlementOrderDailySumPageable?.totalElements;
        if (totalElements) {
            setTotal(totalElements);
        }
    }, [data]);

    return {
        realtimeSettlementOrderDailySumData,
        loading: loading || queryLoading,
        refetch,
        totalElements: total,
        buildQueryVariables
    };
};
